import SwiperCarousel from 'utils/swiper-carousel';
import { shopliftTesting } from 'utils/shoplift-testing';
import '../product/countdown';

export default (element, data) => {
  shopliftTesting(element.querySelector('[data-hypothesis]'), data);
  
  const promoSlider = element.querySelector('[data-promo-bar-slider]');
  const countdownHolder = element.querySelector('.countdown__content');
  let countdownSlide = element.querySelector('.countdown-swiper-slide');

  const showArrows = () => {
    element.querySelector('.next')?.classList.remove('!hidden');
    element.querySelector('.prev')?.classList.remove('!hidden');
  }

  const showSlides = () => {
    const hiddenPromoMessageSlides = element.querySelectorAll('.swiper-slide.hidden');
    hiddenPromoMessageSlides.forEach(slide => slide.classList.remove('hidden'));
  }

  const hideSection = () => {
    if (element.classList.contains('countdown-promo-bar')) {
      element.classList.add('hidden');
    }
  }

  if (countdownHolder) {
    if (countdownHolder.classList.contains('hidden')) {
      showSlides();
      showArrows();
    }

    if (countdownHolder.classList.contains('hidden') && countdownSlide && countdownSlide.classList.contains('countdown-swiper-slide--hide')) {
      countdownSlide.classList.add('!hidden');
      hideSection();
    } else {
      countdownSlide?.classList.remove('!hidden');
    }
  }

  const init = () => {
    // eslint-disable-next-line no-new
    const promoSliderInstance = new SwiperCarousel(promoSlider, {
      slidesPerView: 1,
      centeredSlides: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 3000,
      },
      loop: false,
      rewind: true,
      breakpoints: {
        768: {
          navigation: {
            nextEl: element.querySelector('.next'),
            prevEl: element.querySelector('.prev'),
          }
        }
      }
    });

    window.addEventListener('theme:countdown:end', () => {
      countdownSlide = element.querySelector('.countdown-swiper-slide');
      
      if (countdownHolder && countdownHolder.classList.contains('hidden') && countdownSlide && countdownSlide.classList.contains('countdown-swiper-slide--hide')) {
        countdownSlide.classList.add('!hidden');
        hideSection();
      } else {
        countdownSlide?.classList.remove('!hidden');
      }
      
      showSlides();
      showArrows();
      
      promoSliderInstance.swiper?.update();
    });

    const observer = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'attributes' && mutation.target.classList.contains('countdown-swiper-slide') && mutation.target.style.display === 'none') {
          showSlides();
          showArrows();
          hideSection();

          const hiddenPromoMessageSlides = element.querySelectorAll('.swiper-slide');
          if (hiddenPromoMessageSlides.length === 1) {
            element.classList.add('hidden');
          }

          promoSliderInstance.swiper?.update();
          observer.disconnect();
        }

        setTimeout(() => {
          observer.disconnect();
        }, 10000);
      }
    });

    observer.observe(element, { attributes: true, childList: true, subtree: true });

    return promoSlider;
  };

  init();
};
